module.exports = __webpack_public_path__ + "static/media/anatomia.33e85702.png";